import { memo } from 'react';
import { getSessionUserState } from '@client/selectors/helpers/login';
import { useSelector } from '@client/hooks/redux.hooks';
import { LoggedOut } from './LoggedOut';
import { Redeem } from './Redeem';
import type { RedeemableTicket } from '@sda/interfaces/ticket';

export const RedemptionCTA = memo<RedeemableTicket>(({ ...data }) => {
  const userState = useSelector(getSessionUserState);

  if (!userState) {
    return <LoggedOut />;
  }

  return <Redeem {...data} />;
});

export default RedemptionCTA;
